import { render, staticRenderFns } from "./KeywordTrendChart.vue?vue&type=template&id=6aed1c91"
import script from "./KeywordTrendChart.vue?vue&type=script&lang=js"
export * from "./KeywordTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports